import { ChangeEvent } from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { FieldLabel, SectionTitle } from "../../Product/shared/FormField";
import {
  COMPANY_PROFILE_SECTIONS,
  CompanyProfileDraft,
  CompanyProfileErrors,
  CompanyProfileField,
  isCompanyProfileField,
} from "./companyProfileDraft";

const FIELD_SIZE = { xs: 12, md: 6 };

interface CompanyProfileFormProps {
  draft: CompanyProfileDraft;
  errors: CompanyProfileErrors;
  disabled: boolean;
  onChangeField: (field: CompanyProfileField, value: string) => void;
}

/** The seller fields, section by section; presentational — the tab owns saving. */
export default function CompanyProfileForm({
  draft,
  errors,
  disabled,
  onChangeField,
}: Readonly<CompanyProfileFormProps>) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (isCompanyProfileField(name)) onChangeField(name, value);
  };

  return (
    <Stack gap={1}>
      {COMPANY_PROFILE_SECTIONS.map((section) => (
        <Stack key={section.title}>
          <SectionTitle>{section.title}</SectionTitle>
          <Grid container columnSpacing={2} rowSpacing={2}>
            {section.fields.map((definition) => (
              <Grid key={definition.field} size={FIELD_SIZE}>
                <FieldLabel required={!definition.isOptional}>{definition.label}</FieldLabel>
                <TextField
                  name={definition.field}
                  value={draft[definition.field]}
                  onChange={handleChange}
                  disabled={disabled}
                  error={Boolean(errors[definition.field])}
                  helperText={errors[definition.field] ?? definition.helperText}
                  slotProps={{
                    htmlInput: {
                      maxLength: definition.maxLength,
                      inputMode: definition.digitCount ? "numeric" : undefined,
                    },
                  }}
                  size="small"
                  fullWidth
                />
              </Grid>
            ))}
          </Grid>
        </Stack>
      ))}
    </Stack>
  );
}
